import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex filter-wrapper filter-inner-wrapper flex-row toggle-click-parent" }
const _hoisted_2 = {
  key: 0,
  class: "toggle-click-child"
}
const _hoisted_3 = { class: "toggle-click-child" }
const _hoisted_4 = { class: "toggle-click-child" }
const _hoisted_5 = { class: "toggle-click-child" }
const _hoisted_6 = { class: "flex-fill toggle-click-parent max-width" }

import DatePicker from './DatePicker.vue'
import LiveButton from './LiveButton.vue'
import Last24Hours from './LastXHoursButton.vue'
import Slider from './TimeRange.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import { DateTimeFilterTypes } from '@/utilities/enums'
import PlayButton from './PlayButton.vue'
import { useSlots } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DateTimeFilterBar',
  props: {
  isLoading: Boolean
},
  emits: ['filterValueChanged'],
  setup(__props, { emit: __emit }) {

const slots = useSlots()

const activeButton = ref(DateTimeFilterTypes.Live)

const isLiveActive = computed(() => activeButton.value === DateTimeFilterTypes.Live)
const isLast24Active = computed(() => activeButton.value === DateTimeFilterTypes.Last24)
const isDatePickerActive = computed(() => activeButton.value === DateTimeFilterTypes.DatePicker)

const emit = __emit

const dateTimeStore = useDateTimeStore()
const isPlayingLive = ref(false)

let timerId: any | null = null

let previousCounter = ref(dateTimeStore.updateCounter)



function clickPlayLive() {
  if (isPlayingLive.value) {
    stopActiveTimer()
  } else {
    startActiveTimer()
  }
}

function checkUpdateCounter() {
  if (dateTimeStore.updateCounter !== previousCounter.value) {
    previousCounter.value = dateTimeStore.updateCounter
    clearTimeout(timerId)
    dateTimeStore.incrementTime()
  }
  // for optimal playback speed
  timerId = setTimeout(checkUpdateCounter, 4000)
}

function watchUpdateCounter() {
  checkUpdateCounter()
}

function startActiveTimer() {
  isPlayingLive.value = true
  previousCounter.value = dateTimeStore.updateCounter

  dateTimeStore.incrementTime()

  watchUpdateCounter()
}

function stopActiveTimer() {
  isPlayingLive.value = false
  if (timerId) {
    clearTimeout(timerId)
    timerId = null
  }
}

const setActive = (type: DateTimeFilterTypes) => {
  activeButton.value = type

  if (type === DateTimeFilterTypes.Live) {
    stopActiveTimer()
    dateTimeStore.setIsLive(true)
    dateTimeStore.setDateTime(new Date())
    emit('filterValueChanged', { filterTimestamp: null })
  } else {
    dateTimeStore.setIsLive(false)
  }
}

watch(
  () => dateTimeStore.resetCounter,
  () => {
    setActive(DateTimeFilterTypes.Live)
  }
)

watch(
  () => dateTimeStore.haltPlayButton,
  (newVal) => {
    if (newVal) {
      stopActiveTimer()
      setActive(DateTimeFilterTypes.Live)
      dateTimeStore.updateHalting(false)
    }
  }
)

onMounted(() => {
  setActive(DateTimeFilterTypes.Live)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(slots).search)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "search")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(LiveButton, {
        isActive: isLiveActive.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setActive(_unref(DateTimeFilterTypes).Live)))
      }, null, 8, ["isActive"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Last24Hours, {
        isActive: isLast24Active.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setActive(_unref(DateTimeFilterTypes).Last24)))
      }, null, 8, ["isActive"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(DatePicker, {
        isActive: isDatePickerActive.value,
        onOnOpen: _cache[2] || (_cache[2] = ($event: any) => (setActive(_unref(DateTimeFilterTypes).DatePicker)))
      }, null, 8, ["isActive"])
    ]),
    _createElementVNode("div", {
      class: "toggle-click-child",
      onClick: _cache[3] || (_cache[3] = () => clickPlayLive())
    }, [
      _createVNode(PlayButton, {
        "is-live-active": isLiveActive.value,
        "is-playing-live": isPlayingLive.value
      }, null, 8, ["is-live-active", "is-playing-live"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Slider, {
        isLoading: __props.isLoading,
        state: activeButton.value
      }, null, 8, ["isLoading", "state"])
    ])
  ]))
}
}

})